// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"624":"clere","738":"course-manager","888":"course-setup"}[chunkId] || chunkId) + "." + {"160":"1b5211af","354":"024f89c5","368":"5c83349e","579":"eea4ae27","624":"6822f907","668":"f583838e","738":"b497fbaa","833":"ca10eda1","838":"3787910e","888":"7a871297"}[chunkId] + ".js";
};